/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-10 09:32:13
 * @LastEditors: linxi
 * @LastEditTime: 2025-05-23 17:12:21
 */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import {
  DateSelect as DateSelectOne,
  RecentTime,
  RecentTimePotion,
  getDateRange,DateRangeType
} from '../../../../compnents/date/TimeSelect'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { getSupplierList } from '../../OReplaceMakeSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { SupplierListResponse } from '../../../../services/OReplaceMake'
import styles from './order.module.css'

export const Query = (props: {
  loading?: any
  exportLoading?: any
  initValue?: any
  onValueChange: (queries: any) => void
  onExport: () => void
}) => {
  const [form] = Form.useForm()

  const [head, tail] = getDateRange(DateRangeType.ThisMonth)

  const dispatch = useDispatch<RootDispatch>()

  const [supplierOptions, setSupplierOptions] = useState<
    Array<SupplierListResponse>
  >([])

  const payStatus = [
    {
      value: 1,
      label: '已结算',
    },
    {
      value: 0,
      label: '已退费',
    },
  ]
  const replaceType = [
    {
      value: 20,
      label: '本地代煎所有',
    },
    {
      value: 21,
      label: '本地代煎袋装液体',
    },
    {
      value: 22,
      label: '本地代煎颗粒剂',
    },
  ]

  useEffect(() => {
    dispatch(getSupplierList())
      .then(unwrapResult)
      .then((res: Array<SupplierListResponse>) => {
        setSupplierOptions(res)
      })
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(v) => {
        if(!v?.pullTimeHead && v?._dateRange == 6){
          return 
        }
        const time = {
          pullTimeHead: null,
          pullTimeTail: null,
          createListTimeHead: v?.pullTimeHead || head,
          createListTimeTail: v?.pullTimeTail || tail,
        }
        props.onValueChange({ ...v, ...time })
      }}
      style={{ paddingBottom: '20px' }}
    >
      <Row>
        <Space>
          <Form.Item name='param' noStyle>
            <Input
              size='middle'
              placeholder='患者姓名/手机号/助记码'
              maxLength={20}
              onChange={form.submit}
              allowClear
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='boilType' noStyle>
            <Select
              allowClear
              placeholder='代煎类别'
              onChange={form.submit}
              dropdownClassName={styles.select}
            >
              {replaceType.map((c) => (
                <Select.Option key={c.label} value={c.value}>
                  代煎类别-{c.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              allowClear
              placeholder='结算状态'
              onChange={form.submit}
              dropdownClassName={styles.selects}
            >
              {payStatus.map((c) => (
                <Select.Option key={c.label} value={c.value}>
                  结算状态-{c.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item noStyle>
            <DateSelectOne
              style={{width:'6rem'}}
              allowClear={false}
              placeholder='开单时间'
              options={RecentTimePotion}
              labelPrefix=''
              onChange={form.submit}
              initialValue={DateRangeType.ThisMonth}
              namePrefix='pullTime'
            />
          </Form.Item>
          <Button htmlType='submit' type='primary' loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type='primary' loading={props.exportLoading} onClick={() => props.onExport()}>
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
